import { Phone } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-black/95 backdrop-blur-md border-t border-neutral-900 p-3 grid grid-cols-2 gap-2"
    >
      <a
        href="tel:4033935772"
        data-testid="sticky-call-btn"
        className="inline-flex items-center justify-center gap-2 border border-[#F5F5F0] text-[#F5F5F0] py-3 font-semibold"
      >
        <Phone size={16} /> Call
      </a>
      <a
        href="#quote-form"
        data-testid="sticky-quote-btn"
        className="inline-flex items-center justify-center bg-[#F5F5F0] text-black py-3 font-semibold"
      >
        Get a Quote
      </a>
    </div>
  );
}
